import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { openPrintDialog } from 'app/infrastructure/platform';
import { AuthState } from 'app/types-shared';
import get from 'lodash/get';
import { keyCodeTypes } from 'ui/common/key-code-types';

export function withPrint<P>(){
  return (
    WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>
  ) => {

    return class extends React.Component<P & { url: string; print: boolean }> {
      private ref:React.RefObject<HTMLDivElement> = React.createRef();

      public addListeners () {
        window.addEventListener('keydown', this.handleKeyboardEvent);
      }

      public removeListeners () {
        window.removeEventListener('keydown', this.handleKeyboardEvent);
      }

      private handleKeyboardEvent = (e:KeyboardEvent) => {
        if (
          (e.metaKey || e.ctrlKey) && e.code === keyCodeTypes.KeyP &&
          get(this.props, 'sharedState.authState') as AuthState !== AuthState.Anonymous
        ) {
          const {url} = this.props;
          e.preventDefault();
          navigate.toPrintCaseView(url);
        }
      };

      public componentDidMount () {
        const { print } = this.props;

        if (print) {
          const loadingImages = document.querySelectorAll('.image-loading');
          let loading = loadingImages.length;
          const config = {childList: true, subtree:true};

          const call = (_, observer) => {
            loading--;
            observer.disconnect();
            if (loading === 0) {
              openPrintDialog();
            }
          };

          loadingImages.forEach(placeholder => {
            const observer = new MutationObserver(call);
            observer.observe(placeholder.parentElement, config);
          });

          if(loading === 0) {
            openPrintDialog();
          }
        } else {
          this.addListeners();
        }
      }

      public componentWillUnmount() {
        this.removeListeners();
      }

      public render() {
        if (this.props.print) {
          return <div ref={this.ref}><WrappedComponent ref={this.ref} {...this.props} /></div>;
        }

        return <WrappedComponent ref={this.ref} {...this.props} />;
      }
    };
  };
}
